export default __webpack_public_path__ + "static/media/Digital_2_Pin_Input@2x.7dd57896.png";